import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { ConfigService } from 'src/app/shared/config';

@Injectable({
    providedIn: 'root',
})
export class AnnouncementService {
    constructor(private firestore: AngularFirestore, private config: ConfigService) {

    }

    // Add a new announcement
    addAnnouncement(announcement: any): Promise<any> {
        return this.firestore.collection('announcements').add(announcement);
    }
    updateAnnouncement(id,announcement: any): Promise<any> {
        return this.firestore.collection('announcements').doc(id).update(announcement);
    }
    // Delete an announcement
    deleteAnnouncement(announcementId: string): Promise<void> {
        return this.firestore.collection('announcements').doc(announcementId).delete();
    }

    // Get all systems
    getSystems(): Observable<any[]> {
        return this.firestore.collection('system_info', ref => ref.where("companyId", "==", this.config.getCompanyId())).snapshotChanges().pipe(map(docs => {
            return docs.map(doc => {
                const d = doc.payload.doc.data() as any;
                return {
                    ...d,
                    id: doc.payload.doc.id,
                    systemId: doc.payload.doc.id,
                    systemName: d.name || doc.payload.doc.id,
                };
            });
        }));
    }

    // Get all categories
    getAnnouncements(): Observable<any[]> {
        return this.firestore.collection('announcements').snapshotChanges();
    }


}